<template>
  <div class="mt-1 p-3 bg-branddark text-gray-300 text-left text-xs border-t-4 border-brandlight">&copy; {{year}} AddACCION | All rights reserved</div>
</template>

<script>
export default {
  data(){
    return{
      year: new Date().getFullYear()
    }
  }
}
</script>

<style>

</style>